module.exports = __webpack_public_path__ + "img/guanghua-tab3.1484c36a.png";